import { SvgIcon } from '@mui/material';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconActivityWineTastingComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 22h8" fill="none" />
        <path d="M7 10h10" fill="none" />
        <path d="M12 15v7" fill="none" />
        <path d="M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z" fill="none" />
      </svg>
    </SvgIcon>
  );
};

IconActivityWineTastingComponent.displayName = 'IconActivityWineTasting';

const IconActivityWineTasting = React.memo(IconActivityWineTastingComponent);

export default IconActivityWineTasting;
